import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { IndividualCheckResponse } from "../types/Individual";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string, individualCheckId: number) => () =>
  axios.get<IndividualCheckResponse>(
    `${env.verifyServiceUrl}individual/monitoring_activity/${individualCheckId}/`,
    {
      headers: {
        Authorization: authHeader,
      },
    }
  );

// Deliberately NOT "individualCheckDetails": that key belongs to useIndividualCheck,
// which reads individual/check/{id}/. Both hooks take an id from a different table, so
// sharing a key made one overwrite the other's cache and invalidating either cleared both.
export const monitoringActivityQueryKey = (id: number | string) => [
  "monitoringActivityDetails",
  id,
];

export const useMonitoringActivityView = (id: number) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(monitoringActivityQueryKey(id), fetch(authHeader, id), {
    retry: false,
    enabled: !!id,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
